<div id="wrap" class="moWrap">
  <header class="header">
      <div class="header_inner">
          <h1 class="header_logo">
              <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
          </h1>
          <span class="util_right">
              <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
          </span>
      </div>
  </header>

  <div id="content">
    <div id="skip_anchor" class="content page_guide">
        <div class="form_guide">
          <div class="center_title">
              <h2>이용가이드</h2>
          </div>
            <div class="guide_tab">
                <ng-container *ngFor="let item of contentCategoryList">
                    <button type="button" (click)="selectCategory(item.contentCategoryNo)" [ngClass]="item.contentCategoryNo == contentCategoryNo ? 'active': ''" [attr.contentCategoryNo]="item.contentCategoryNo" class="tab_item">{{item.contentCategoryName}}</button>
                </ng-container>
            </div>
            <ul class="guide_list">
                <ng-container *ngIf="guideList && guideList.length > 0">
                    <li class="guide_item" *ngFor="let item of guideList">
                        <button type="button" [ngClass]="item.selected ? 'open': ''" (click)="selectContent(item)" class="guide_label">{{item.title}}</button>
                        <div class="guide_text">
                            <pre>{{item.webDescription}}</pre>
                        </div>
                    </li>
                </ng-container>
                <ng-container *ngIf="!(guideList && guideList.length > 0)">
                    <li class="guide_item guide_no">등록된 가이드가 존재하지 않습니다.</li>
                </ng-container>
            </ul>
        </div>
    </div>
  </div>
  <footer class="footer">
    <div class="footer_inner">
        <div class="footer_menu">
            <a routerLink="/m/guide">이용가이드</a>
            <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="emphasis">개인정보처리방침</a>
            <a routerLink="/terms">약관 및 정책</a>
        </div>
    </div>
  </footer>
</div>
